import { lumappsTaskList } from '@lumapps/lumx/custom-icons';
import { mdiBell } from '@lumapps/lumx/icons';

/**
 * Maps a modern notification's `icon` key (a static string the backend documents per
 * notification type) to a local, bundled icon asset — as opposed to the legacy `iconProps.icon`
 * mechanism, which resolves MDI icon names remotely via `useDynamicIcon` (CDN fetch).
 *
 * Only `task_check` is confirmed by the backend spec so far; extend this map as more keys
 * are documented.
 */
const MODERN_NOTIFICATION_ICON_MAP: Record<string, string> = {
    task_check: lumappsTaskList,
};

const DEFAULT_MODERN_NOTIFICATION_ICON = mdiBell;

export const getModernNotificationIconPath = (icon?: string): string =>
    (icon && MODERN_NOTIFICATION_ICON_MAP[icon]) || DEFAULT_MODERN_NOTIFICATION_ICON;
